module.exports = __webpack_public_path__ + "static/instagram-f0c757924a5c15a1a77f2a51e6e1a717.png";